import { AfspLayout } from '@bit/ui-common.ui-components/afsp';
import { SsStepper } from '@bit/ui-common.ui-components/ss-components';
import { Icon } from 'antd';
import StepperHeader from '../registration/candidate/StepperHeader';
import Welcome from '../registration/candidate/Welcome';
import Personal from '../registration/candidate/Personal';
import Passport from '../registration/candidate/Passport';
import IdAndEmail from '../registration/candidate/IdAndEmail';
import Security from '../registration/candidate/Security';
import Signature from '../registration/candidate/Signature';
import Submit from '../registration/candidate/Submit';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const
{ SsStepperLayout, SsStep } = SsStepper,
{ setEnvPrefix } = ssCommonUtils,
imagesPath = '/home/images',
afspLayout = {
    bgc: '#e6e6e6',
    controlType: 'home',
    size: { header: 'xs', footer: 'xs' },
    images: {
        usePathname: false,
        logo: setEnvPrefix(`${imagesPath}/dhs-logo-01.png`),
        user: setEnvPrefix(`${imagesPath}/user-icon-01.png`),
    }
};

export default class CandidateLayout extends React.Component {
    constructor(props) {
        super(props);
        this.common = { utils: { updateTitle: this.updateTitle }};
    }

    updateTitle(stepNumber, icon, service, prevStatus, currStatus) {
        const
        title = s => (<div><Icon type={s} />{` Step ${stepNumber}`}</div>);
        if(prevStatus === 'invalid' && currStatus === 'valid') service(title('check-circle-o'));
        else if(prevStatus === 'valid' && currStatus === 'invalid') service(title(icon));
    }

    render() {
        const
        { services, candidate, commonData, registrationForm } = this.props,
        { registrationRequest } = candidate,
        { status, code } = registrationRequest,
        { textData } = commonData,
        stepperLayout = {
            id: 'candidate-registration',
            state: candidate,
            services: services
        };

        return (
            <div>
                <AfspLayout {...afspLayout}>
                    <SsStepperLayout {...stepperLayout} header={<StepperHeader text={textData.textDataStore} />} progressDot>
                        <SsStep
                            id='welcome'
                            description='Welcome'
                            title={(<div><Icon id='candidate-registration-welcome' type='home' style={{ marginRight: '6px' }}/></div>)}
                            render={() => <Welcome {...this.common} {...this.props} />}
                        />
                        <SsStep
                            id='personal'
                            description='Enter Personal Information'
                            title={(<div><Icon type='user' id='candidate-registation-personal-info' style={{ marginRight: '6px' }}/>{'Step 1'}</div>)}
                            render={() => <Personal {...this.common} {...this.props} />}
                        />
                        <SsStep
                            id='passport'
                            description='Enter Passport Information'
                            title={(<div><Icon type='idcard' id='candidate-registration-passport' style={{ marginRight: '6px' }}/>{'Step 2'}</div>)}
                            render={() => <Passport {...this.common} {...this.props} />}
                        />
                        <SsStep
                            id='email'
                            description='Create a User ID'
                            title={(<div><Icon type='mail' id='candidate-registration-user-id' style={{ marginRight: '6px' }}/>{'Step 3'}</div>)}
                            render={() => <IdAndEmail {...this.common} {...this.props} />}
                        />
                        <SsStep
                            id='security'
                            description='Create Security Questions'
                            title={(<div><Icon type='lock' id='candidate-registration-security-questions' style={{ marginRight: '6px' }}/>{'Step 4'}</div>)}
                            render={() => <Security {...this.common} {...this.props} />}
                        />
                        <SsStep
                            id='signature'
                            description='Verify / Digitally Sign'
                            title={(<div><Icon type='edit' id='candidate-registration-signature' style={{ marginRight: '6px' }}/>{'Step 5'}</div>)}
                            render={() => <Signature {...this.common} {...this.props} />}
                        />
                        <SsStep
                            id='submit'
                            description='Submit'
                            title={(<div><Icon type='login' id='candidate-registration-submit' style={{ marginRight: '6px' }}/>{'Step 6'}</div>)}
                            render={() => <Submit {...this.common} {...this.props} />}
                            fullState
                        />
                    </SsStepperLayout>
                </AfspLayout>
            </div>
        )
    }
}
